import VueRouter from '../../lib/utils/vue3compat/vue_router.js?vue3';
import { createAlert } from '../../alert.js?vue3';
import { __ } from '~/locale';
import { pipelineTabName } from './constants';
import { createPipelineHeaderApp } from './pipeline_header.js?vue3';
import { apolloProvider } from './pipeline_shared_client.js?vue3';

const SELECTORS = {
  PIPELINE_HEADER: '#js-pipeline-header',
  PIPELINE_TABS: '#js-pipeline-tabs',
};

export async function initPipelineDetails() {
  const headerSelector = SELECTORS.PIPELINE_HEADER;

  const headerEl = document.querySelector(headerSelector);

  if (headerEl) {
    const { dataset: headerDataset } = headerEl;

    try {
      createPipelineHeaderApp(headerSelector, apolloProvider, headerDataset.graphqlResourceEtag);
    } catch {
      createAlert({
        message: __('An error occurred while loading a section of this page.'),
      });
    }
  }

  const tabsEl = document.querySelector(SELECTORS.PIPELINE_TABS);

  if (tabsEl) {
    let validityChecksEnabled;

    const { dataset } = tabsEl;
    const dismissalDescriptions = JSON.parse(dataset.dismissalDescriptions || '{}');
    const { createAppOptions } = await import('../../../../../ee/app/assets/javascripts/ci/pipeline_details/pipeline_tabs.js?vue3');
    const { createPipelineTabs } = await import('./pipeline_tabs.js?vue3');
    const { routes } = await import('../../../../../ee/app/assets/javascripts/ci/pipeline_details/routes.js?vue3');

    try {
      validityChecksEnabled = JSON.parse(dataset.validityChecksEnabled);
    } catch {
      validityChecksEnabled = 'false';
    }

    // eslint-disable-next-line @gitlab/no-hardcoded-urls -- '/security' is a Vue Router route path, not a Rails URL
    const securityRoute = routes.find((route) => route.path === '/security');
    if (securityRoute) {
      securityRoute.props = { dismissalDescriptions, validityChecksEnabled };
    }

    const router = new VueRouter({
      mode: 'history',
      base: dataset.pipelinePath,
      routes,
    });

    // We handle the shortcut `pipelines/latest` by forwarding the user to the pipeline graph
    // tab and changing the route to the correct `pipelines/:id`
    if (window.location.pathname.endsWith('latest')) {
      router.replace({ name: pipelineTabName });
    }

    try {
      const appOptions = createAppOptions(SELECTORS.PIPELINE_TABS, apolloProvider, router);
      createPipelineTabs(appOptions);
    } catch {
      createAlert({
        message: __('An error occurred while loading a section of this page.'),
      });
    }
  }
}
